import React from 'react';
import Nav from 'components/sidebar/nav.jsx';
import 'components/sidebar/index.scss';

const SideBar = () => {
  return <Nav />;
};

export default SideBar;
